// @flow
import React from 'react';
import {connect} from 'react-redux';
import {PRICE_LABEL_MODAL} from '../../actions/modals';
import routerActions from '../../actions/router';
import DualPriceTooltip from './DualPriceTooltip';

import type {State as ReduxState} from '../../reducers';
import type {Node} from 'react';

type DispatchProps = {
    openPriceLabelModal: () => void,
    closePriceLabelModal: () => void
};

type StateProps = {
    isOpen: boolean
};

type OwnProps = {
    isDesktop: boolean,
    content: string,
    children: Node
};

export type Props = OwnProps & StateProps & DispatchProps;

const DualPriceTooltipContainer = (props: Props) => {
    return <DualPriceTooltip {...props} />;
};

const mapStateToProps = ({modals}: ReduxState): StateProps => {
    return {
        isOpen: modals.PRICE_LABEL.isOpen
    };
};

const mapDispatchToProps = {
    openPriceLabelModal: () => routerActions.pushModal(PRICE_LABEL_MODAL),
    closePriceLabelModal: () => routerActions.popModal(PRICE_LABEL_MODAL)
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DualPriceTooltipContainer);
